import React from "react";
import EvaToolDetailContainer from "containers/eva/EvaToolDetailContainer";

const EvaToolDetailPage: React.FC = () => {
  return <EvaToolDetailContainer />;
};

export default EvaToolDetailPage;
